import { render, staticRenderFns } from "./DashBusiness.vue?vue&type=template&id=55b0b830&scoped=true&"
import script from "./DashBusiness.vue?vue&type=script&lang=js&"
export * from "./DashBusiness.vue?vue&type=script&lang=js&"
import style0 from "./DashBusiness.vue?vue&type=style&index=0&id=55b0b830&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b0b830",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSheet,VSimpleTable})
